import React,{useState,useEffect,lazy} from 'react';
import axios from 'axios'
import {  Slider,Statistic,Tabs,Modal } from 'antd';
import { ArrowUpOutlined,MinusCircleFilled,ToolOutlined, ArrowDownOutlined,FileFilled,WalletFilled,SearchOutlined,FundViewOutlined,
   UserOutlined, AccountBookOutlined,CalculatorFilled,SwapOutlined,GroupOutlined,AccountBookFilled, DollarCircleOutlined,EditFilled,MessageFilled,DollarOutlined,CarFilled,LoadingOutlined,PlusCircleFilled } from '@ant-design/icons';
import moment from 'moment';
import {withGetScreen} from 'react-getscreen'
import { Popover,Table,Popconfirm,Input, Button,Collapse,Card,Avatar,Form,DatePicker,Select,Space,Typography,Divider,InputNumber,message,Spin } from 'antd';
import * as serverconfig from '../../serverconn';


import { Bar } from 'react-chartjs-2';
//import { Chart as ChartJS } from 'chart.js/auto'; // This imports everything you need automatically


var CryptoJS = require("crypto-js");

const { TextArea } = Input;
const antIcon = <LoadingOutlined style={{ fontSize: 40 }} spin />;


const style = { background: '#0092ff', padding: '8px 0',borderRadius: '7px',justifyContent:'center', alignItems:'center',display: 'flex', };
const dateFormat = 'DD/MM/YYYY';
const yeardateFormat = 'YYYY';
const monthdateFormat = 'MM/YYYY';

const { Meta } = Card;
const { Panel } = Collapse;
const { TabPane } = Tabs;
const FormItem=Form.Item;
const { Option } = Select;

var bizuserid= ''
var sacco= ''
var token= ''


class TrackingGraph extends React.Component {

  state = {
    datarequested:true,
    tracking_hubs_report:[]
  };


  componentDidMount(){
    // If props are provided (used as child component), use them
    if (this.props.tracking_hubs_report) {
      this.setState({tracking_hubs_report:this.props.tracking_hubs_report})
      this.setState({datarequested:false})
    } else {
      // If no props (used as standalone route), fetch data
      this.fetchTrackingData();
    }
  }

  fetchTrackingData = () => {
    const token = localStorage.getItem('token');
    const form_data = new FormData();
    
    // Set default date range (last 30 days)
    const endDate = moment();
    const startDate = moment().subtract(30, 'days');
    
    form_data.append('dateone', startDate.format('DD/MM/YYYY'));
    form_data.append('datetwo', endDate.format('DD/MM/YYYY'));
    form_data.append('region', '');
    form_data.append('district', '');
    form_data.append('hub', '');

    this.setState({datarequested: true});
    
    axios.post(serverconfig.backendserverurl+'/customqueries/get_hubs_visited_statistics', form_data, {
      headers: {
        'content-type': 'multipart/form-data',
        'Authorization': `Token ${token}`
      }
    })
    .then(res => {
      this.setState({
        tracking_hubs_report: res.data.tracking_hubs_report || [],
        datarequested: false
      });
    })
    .catch(error => {
      console.error('Error fetching tracking data:', error);
      message.error('Failed to load tracking data');
      this.setState({
        tracking_hubs_report: [],
        datarequested: false
      });
    });
  }


render() {
      if(this.state.datarequested===true){
        return(
          <div style={{display: 'flex',  justifyContent:'center', alignItems:'center', minHeight: '400px' }}>
                <Spin size="large">
                <div className="content">
                  <h3>Loading Hub Visit Statistics...</h3>
                </div>
                </Spin>        
          </div>
        )
      }else{

            const chartData = {
              labels:  this.state.tracking_hubs_report.map(item =>item.name),
              datasets: [
                {
                  label: '% Visited',
                  data: this.state.tracking_hubs_report.map(item => item.percentage_vist),
                  backgroundColor: 'rgba(75, 192, 192, 0.6)',
                  borderRadius: 5,     
                },
                
              ],
            };
        
            const options = {
              responsive: true,
              plugins: {
                legend: {
                  position: 'top',
                },
                title: {
                  display: true,
                  text: 'HUB VISITS',
                },
              },
              scales: {
                x: {
                  beginAtZero: true,
                },
                y: {
                  beginAtZero: true,
                  },
              },
            };


      // Check if being used as standalone component (no props) or child component
      const isStandalone = !this.props.tracking_hubs_report;
      
      if (isStandalone) {
        return (
          <div className="animated fadeIn">
            <Card 
              title="Hub Visit Statistics" 
              style={{ margin: '16px 0' }}
              extra={
                <Button 
                  type="primary" 
                  onClick={this.fetchTrackingData}
                  loading={this.state.datarequested}
                >
                  Refresh Data
                </Button>
              }
            >
              {this.state.tracking_hubs_report.length > 0 ? (
                <div style={{ height: '400px' }}>
                  <Bar data={chartData} options={options} />
                </div>
              ) : (
                <div style={{ textAlign: 'center', padding: '40px' }}>
                  <p>No hub visit data available</p>
                  <Button type="primary" onClick={this.fetchTrackingData}>
                    Load Data
                  </Button>
                </div>
              )}
            </Card>
          </div>
        );
      } else {
        return (
          <div className="animated fadeIn"> 
            <Bar data={chartData} options={options} />
          </div>
        );
      }

    }
    
  
 

}
}

export default TrackingGraph; 
